import { render, staticRenderFns } from "./GlobalShippingDialog.vue?vue&type=template&id=08185f80&scoped=true"
import script from "./GlobalShippingDialog.vue?vue&type=script&lang=ts"
export * from "./GlobalShippingDialog.vue?vue&type=script&lang=ts"
import style0 from "./GlobalShippingDialog.vue?vue&type=style&index=0&id=08185f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08185f80",
  null
  
)

export default component.exports